import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import Select, { SingleValue } from "react-select";
import { SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { IChatGptPrompt } from "../dto/IChatGptPrompt";
import { useSelector } from "react-redux";
import { IAllStates } from "../../../store/rootReducer";
import { themeSelect } from "../../../shared/components/Select2";
import { getCorrectLanguage } from "../../../shared/functions/Functions";
import Switch from "react-switch";
interface IExportFormProps {
  setIsMenuOpened: React.Dispatch<SetStateAction<boolean>>;
  state: IChatGptPrompt | undefined;
  setState: React.Dispatch<SetStateAction<IChatGptPrompt | undefined>>;
  dataEnrichmentList: any[];
  // clientList: IClient[];
  // changeClientHandler: (value: string) => void;
}

export const PromptCreate = ({
  setIsMenuOpened,
  state,
  setState,
  dataEnrichmentList,
}: IExportFormProps) => {
  // const pages = [
  //   { value: 1, label: "1" },
  //   { value: 2, label: "2" },
  //   { value: 3, label: "3" },
  // ];

  const { t } = useTranslation();
  // const { googleLanguage, googleGeolocation } = useSelector(
  //   (state: IAllStates) => state.enums
  // );
  const { accessRights } = useSelector((state: IAllStates) => state.enums);
  const handleChangeSwitchCopywriter = (key: string, isChecked: boolean) => {
    setState((prev: any) => ({
      ...prev,
      [key]: isChecked,
    }));
    if (!isChecked) {
      setState((prev: any) => ({
        ...prev,
        chatgptPrompt: null,
      }));
    }
  };
  function handleSelectSingle(
    selectedSingle: SingleValue<IChatGptPrompt | null>,
    field: string
  ) {
    if (selectedSingle?.value === undefined) {
      setState((prev: any) => ({
        ...prev,
        [field]: null,
      }));
    } else {
      setState((prev: any) => ({
        ...prev,
        [field]: selectedSingle?.value,
      }));
    }
  }
  const changeHandler = (event: any) => {
    const { name, value } = event.target;
    setState((prev: any) => ({ ...prev, [name]: value }));
  };
  return (
    <Card>
      <Card.Body>
        <Row>
          <Col md={4}>
            <label htmlFor="name" className="required-field">
              {`${t("global.title")}`}
            </label>
            <input
              type="text"
              name="title"
              className="form-control"
              value={state?.title ?? ""}
              required
              onChange={(e) => changeHandler(e as any)}
            />
          </Col>
          <Col md={2} className="mb-2">
            <label className="d-block">
              {t("google_search.product_source_url")}
            </label>
            <div className="mt-2">
              <Switch
                onChange={(checked) =>
                  handleChangeSwitchCopywriter("useProductSourceUrl", checked)
                }
                checked={(state as any)?.useProductSourceUrl as boolean}
              />
            </div>
          </Col>
          {state?.useProductSourceUrl && (
            <Col md={4} className="mb-2">
              <label htmlFor="client" className="">
                {`${t("data_enrichment.data_enrichment")}`}
              </label>
              <Select
                className="react-select-field"
                theme={themeSelect}
                key={state?.id}
                isClearable={true}
                defaultValue={
                  state?.chatgptPrompt
                    ? {
                        value: state?.chatgptPrompt,
                        label: dataEnrichmentList
                          ?.map((item: any) => ({
                            label: item?.title,
                            value: item?.id,
                          }))
                          ?.find(
                            (item: any) =>
                              item?.value == state?.chatgptPrompt?.id
                          )?.label,
                      }
                    : null
                }
                onChange={(e) => {
                  handleSelectSingle(e as any, "chatgptPrompt");
                }}
                // isMulti={true}
                options={dataEnrichmentList?.map((item: any) => ({
                  value: item?.id,
                  label: item?.title,
                }))}
              />
            </Col>
          )}

          {/* <Col md={1} className="mb-2">
            <label htmlFor="client" className="required-field">
              {`${t("google_search.pages")}`}
            </label>
            <Select
              className="react-select-field"
              theme={themeSelect}
              key={state?.id}
              defaultValue={
                state?.pages
                  ? {
                      label: state?.pages,
                      value: state?.lang,
                    }
                  : pages[0]
              }
              onChange={(e) => {
                handleSelectSingle(e as any, "pages");
              }}
              // isMulti={true}
              options={(pages as any)?.map((page: any) => ({
                value: page?.value,
                label: page?.label,
              }))}
            />
          </Col> */}

          {/* <Col md={4} className="mb-2">
            <label htmlFor="client" className="">
              {`${t("google_search.geolocation")}`}
            </label>
            <Select
              className="react-select-field"
              theme={themeSelect}
              key={state?.id}
              isClearable={true}
              defaultValue={
                state?.geolocation
                  ? {
                      label: t(`googleGeolocation.${state?.geolocation}`),
                      value: state?.geolocation,
                    }
                  : null
              }
              onChange={(e) => {
                handleSelectSingle(e as any, "geolocation");
              }}
              // isMulti={true}
              options={googleGeolocation?.map((language: string) => ({
                value: language as string,
                label: t(`googleGeolocation.${language}`) as string,
              }))}
            />
          </Col>

          <Col md={4} className="mb-2">
            <label htmlFor="client" className="">
              {`${t("global.language")}`}
            </label>
            <Select
              className="react-select-field"
              theme={themeSelect}
              key={state?.id}
              isClearable={true}
              defaultValue={
                state?.language
                  ? {
                      label: t(`googleLanguage.${state?.language}`),
                      value: state?.language,
                    }
                  : null
              }
              options={googleLanguage?.map((language: string) => ({
                value: language as string,
                label: t(`googleLanguage.${language}`) as string,
              }))}
              onChange={(e) => {
                handleSelectSingle(e as any, "language");
              }}
            />
          </Col> */}
        </Row>
        <Row>
          <Col md={12}>
            <label
              htmlFor="text"
              // className="required-field"
              className={
                state?.useProductSourceUrl === false ? "required-field" : ""
              }
            >
              {`${t("google_search.prompt")}`}
            </label>

            <textarea
              disabled={state?.useProductSourceUrl === true}
              name="prompt"
              onChange={(e) => changeHandler(e as any)}
              value={
                state?.useProductSourceUrl === true ? "" : state?.prompt ?? ""
              }
              className="w-100 dark-text-area"
              placeholder={
                state?.useProductSourceUrl === false
                  ? `${t("mapping.type")}...`
                  : ""
              }
              rows={5}
            />
            {state?.useProductSourceUrl === false && (
              <div
                className="alert alert-warning alert-borderless m-0 p-1"
                role="alert"
              >
                <p className="mb-0">
                  <strong>{t("google_search.available_tags")}:</strong>
                  {` {title}, {subtitle}, {ean}, {pharmaCode}, {articleNumber}, {sapId}, {brand}, {category}`}
                </p>
              </div>
            )}
          </Col>
        </Row>
        <div className="col-12 my-2 d-flex justify-content-end text-align-center">
          <div>
            <button
              className="btn btn-info"
              onClick={() => {
                setIsMenuOpened(false);
                setState({
                  useProductSourceUrl: true,
                });
              }}
            >
              {t("global.cancel")}
            </button>
            <button className="btn btn-primary ms-3" type="submit">
              {state?.id ? `${t("global.update")}` : `${t("global.create")}`}
            </button>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};
